import React from 'react';
import styled from 'styled-components';
import { AvatarGroup as AvatarGroupBase } from '@mui/material';
import Avatar from '../Avatar';

type Size = 'extraSmall' | 'small' | 'medium' | 'large';

const SIZE_MAP: Record<
  Size,
  { width: number; height: number; fontSize: string }
> = {
  extraSmall: { width: 16, height: 16, fontSize: '8px' },
  small: { width: 20, height: 20, fontSize: '9px' },
  medium: { width: 22, height: 22, fontSize: '10px' },
  large: { width: 32, height: 32, fontSize: '12px' },
};

const AvatarGroupBaseStyled = styled(AvatarGroupBase)<{ $size: Size }>`
  width: fit-content;

  &.MuiAvatarGroup-root {
    align-self: flex-start;
  }

  & .MuiAvatar-root {
    width: ${({ $size }) => SIZE_MAP[$size].width}px;
    height: ${({ $size }) => SIZE_MAP[$size].height}px;
    font-size: ${({ $size }) => SIZE_MAP[$size].fontSize};
  }
`;

const AvatarGroup = ({
  items,
  size = 'medium',
}: {
  items?: string[];
  size?: Size;
}) =>
  items?.length ? (
    <AvatarGroupBaseStyled
      $size={size}
      total={items.length}
      slotProps={{
        additionalAvatar: {
          sx: {
            width: SIZE_MAP[size].width,
            height: SIZE_MAP[size].height,
            fontSize: SIZE_MAP[size].fontSize,
            fontWeight: 'bold',
          },
        },
      }}
    >
      {items.map((o: string) => (
        <Avatar key={o} value={{ name: o }} tooltip={o} size={size} />
      ))}
    </AvatarGroupBaseStyled>
  ) : (
    ''
  );

export default AvatarGroup;
